// extracted by mini-css-extract-plugin
export var label = "_e3-5";
export var slideContainer = "_e3-0";
export var slider = "_e3-1";
export var sliderLg = "_e3-4";
export var sliderMd = "_e3-3";
export var sliderSm = "_e3-2";